module.exports = __webpack_public_path__ + "1a4d2c91285a1b84850c7c35e3c034da.png";